import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Fab from '@material-ui/core/Fab';
import HomeIcon from '@material-ui/icons/Home';

const useStyles = makeStyles((theme) => ({
  icon: {
    borderRadius: 20,
    backgroundColor: '#EEC600',
    color: 'white',
    height: 50,
    width: 50,
    '&:hover': {
      backgroundColor: 'rgba(238,198,0,0.75)'
    }
  },
  iconSvg: {
    fontSize: '1.6rem'
  }
}));

export const IconHome = (props) => {
  const classes = useStyles();

  return (
      <Fab aria-label="home" className={`${props.className} ${classes.icon}`}>
        <HomeIcon className={classes.iconSvg}/>
      </Fab>
  );
}
